import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weekMonthDate'
})
export class WeekMonthDatePipe implements PipeTransform {

  transform(value: any): any {
    if (!value) { return ''; }

    const datePipe = new DatePipe('en-US');
    const formattedDate = datePipe.transform(value, 'E, MMM d');      // Mon, Nov 3

    return formattedDate;
  }

}
